import { fetchEditionArticlesActionCreator } from '../actions';
import {
  getContentApiUrl,
  getEditionArticleFilters,
  getEditionArticlesPageSize,
  getEditionTraySliceIds,
} from '../selectors';
import fetchJson from './fetchJson';
import createFetchOnHydrationMiddleware from './createFetchOnHydrationMiddleware';

const dispatchFetchArticles = (store, sliceId) => {
  const state = store.getState();
  const apiUrl = getContentApiUrl(state);
  const filters = getEditionArticleFilters(state, sliceId);
  const pageSize = getEditionArticlesPageSize(state, sliceId);
  store.dispatch(fetchEditionArticlesActionCreator(
    sliceId,
    fetchJson(
      'articles',
      [apiUrl, 'edition', 'articles'].join('/'),
      {
        ...filters,
        pageSize,
      },
    ),
  ));
};

export default createFetchOnHydrationMiddleware(getEditionTraySliceIds, dispatchFetchArticles);
